module.exports = __webpack_public_path__ + "img/pr-tree-main.dc285228.svg";